<template lang="html">
  <section @click="onMultiSelectFocus"
           tabindex="0"
           @blur="onMultiSelectBlur"
           @keydown.enter.stop="onMultiSelectFocus"
           @keydown.up.stop="onPressUp"
           @keydown.down.stop="onPressDown"
           @keydown.tab.stop="onPressTab">
    <div class="multi-selection-items">
      <div class="selection-items">
        <div
          v-for="item in listItems"
          :key="item.name"
          class="selected-item"
          :class="{ 'icon-padding': isReadOnly }"
          @click.stop.prevent
        >
          <div
            class="slds-icon_container icon-padding slds-m-left_xx-small slds-icon-utility-text"
            v-if="hasIcon"
          >
            <svg class="slds-icon slds-icon_xx-small">
              <use :xlink:href="getUtilityIcon(item)"></use>
            </svg>
          </div>
          <div>{{ item.label || item.name }}</div>
          <div class="remove-selection">
            <svg @click.prevent="removeItem(item)" v-if="!isReadOnly">
              <use
                xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#close"
              ></use>
            </svg>
          </div>
        </div>
      </div>
      <div class="chevrons" @click.stop.prevent>
        <svg class="chevron-up" v-if="isOpen" @click.prevent="closeDropdown">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevronup"
          ></use>
        </svg>
        <svg class="chevron-down" v-else :class="{ 'grey-chevron': isReadOnly }" @click="onMultiSelectFocus">
          <use
            xlink:href="@/assets/icons/utility-sprite/svg/symbols.svg#chevrondown"
          ></use>
        </svg>
      </div>
    </div>
  </section>
</template>

<script lang="js">
  import iconsUri from "@/views/drag-drop-pages/components/utils/icons-uri";
  export default  {
    name: "multi-selection-items",
    props: {
      isOpen: {
        type: Boolean,
        default: false
      },
      listItems: {
        type: Array
      },
      isReadOnly: {
        type: Boolean
      },
      hasIcon: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      onMultiSelectFocus() {
        if (this.isOpen) {
          this.$emit("on-multi-item-selected");
        } else {
          this.$emit("on-multi-select-focus");
        }
      },
      onMultiSelectBlur() {
        this.$emit("on-multi-select-blur");
      },
      onPressUp() {
        this.$emit("on-up-arrow-pressed");
      },
      onPressDown() {
        this.$emit("on-down-arrow-pressed");
      },
      onPressTab() {
        this.$emit("on-tab-pressed");
      },
      removeItem(item) {
        this.$emit("on-multi-select-remove-item", item);
      },
      closeDropdown() {
        this.$emit("on-multi-select-close-options");
      },
      getUtilityIcon(item) {
        return iconsUri.getUtilityIconByType(item.type);
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "../styles/components/elements";
  .multi-selection-items {
    @include mixin-text-input;
    svg {
      width: 0.8rem;
      height: 1.8rem;
    }
    display: flex;
    justify-content: space-between;
    padding-left: 0.55rem;
    .selection-items {
      display: flex;
      flex-wrap: wrap;
    }
    .chevrons {
      display: flex;
      flex-direction: column;
      cursor: pointer;
    }
    .grey-chevron {
      fill: var(--LIGHT_GRAY);
    }
    .selected-item {
      @include mixin-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-shadow: none;
      height: 24px;
      line-height: 1.8;
      border-radius: 0.3rem;
      padding-left: 0.4rem;
      margin: 0.2rem 0.6rem 0.2rem 0;
      font-size: 0.75rem;
      color: var(--DEFAULT_TEXT_BLACK);
      .remove-selection {
        cursor: pointer;
        margin-left: 0.2rem;
        svg {
          width: 0.8rem;
          height: 0.7rem;
          margin: 0.3rem 0.4rem 0.4rem;
        }
      }
    }
    .icon-padding {
      padding-right: 0.25rem;
    }
    .selected-icon {
      padding-bottom: 8px;
      padding-right: 2px;
    }
  }
</style>
